import React, { Component } from 'react';
import { t } from 'services/translation';

import './index.scss';
import './PaymentError.scss';

class PaymentError extends Component {
  renderPrimaryMessage = () => {
    if (this.props.errorMessage.includes('Try again in a little bit.')) {
      return t('AN_ERROR_OCCURRED_WHILE_PROCESSING_YOUR_CARD');
    }
    if (this.props.errorMessage.includes('security code is incorrect.')) {
      return t('YOUR_CARD_SECURITY_CODE_IS_INCORRECT');
    }
    const regex = /[.,\s]/g;
    return t(
      this.props.errorMessage
        .toUpperCase()
        .split(' ')
        .join('_')
        .replace(regex, '')
    );
  };

  renderSecondaryMessage = () => {
    if (this.props.errorMessage.includes('Try again in a little bit.')) {
      return t('PLEASE_TRY_AGAIN');
    }
    if (this.props.errorMessage.includes('Please')) {
      return '';
    }
    return t('PLEASE_CHECK_YOUR_PAYMENT_INFORMATION_AND_TRY_AGAIN');
  };

  render() {
    return (
      <div className="PaymentError-Container">
        <div className="PaymentError-Message">
          {/* eslint-disable-next-line no-undef */}
          <h1 className="header">{t('PAYMENT_ERROR')}</h1>
          <div className="errorBox">
            <div className="iconBox">
              <i className="fa fa-exclamation-triangle" aria-hidden="true" />
            </div>
            <div className="message">
              {this.renderPrimaryMessage()} {this.renderSecondaryMessage()}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default PaymentError;
